module.exports = __webpack_public_path__ + "assets/f6138e7d13176fb13fe1ae803477dba3.png";